/**
 * @since 7.1.0
 */
export var AttendeeType;
(function (AttendeeType) {
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeType["UNKNOWN"] = "unknown";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeType["PERSON"] = "person";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeType["ROOM"] = "room";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeType["RESOURCE"] = "resource";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeType["GROUP"] = "group";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeType["REQUIRED"] = "required";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeType["NONE"] = "none";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeType["OPTIONAL"] = "optional";
})(AttendeeType || (AttendeeType = {}));
//# sourceMappingURL=attendee-type.js.map